import {
  Box,
  DateFormatted,
  EmployeeThumb,
  LoadingSpinner,
  Table,
  TableItem,
  Tag,
  Time,
  Typography,
} from '@components';
import { RootState, fetchTicketsGeneric, setRootAside } from '@stores';
import { TruncateString } from '@utils';
import React, { useEffect } from 'react';
import { Eye } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';

const TicketLatest = () => {
  const dispatch = useDispatch();

  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  const { tickets, loading } = useSelector((state: RootState) => state.tickets);

  useEffect(() => {
    if (companyId) {
      dispatch(fetchTicketsGeneric({ companyId: companyId }));
    }
  }, [companyId, dispatch]);

  const viewDetail = (ticket: number) => {
    dispatch(
      setRootAside({
        component: 'ticket',
        data: { ticket: ticket },
        title: 'Ticket',
      })
    );
  };

  const displayedTickets = tickets.slice(0, 3);

  return (
    <Box type="bordered" size="medium" gridSize="grid-1">
      {loading ? (
        <LoadingSpinner />
      ) : displayedTickets.length > 0 ? (
        <Table header={[]}>
          {displayedTickets.map((ticket) => (
            <tr key={ticket.id}>
              <TableItem>
                {ticket.tic_med_id && (
                  <EmployeeThumb
                    image={ticket.assignedEmployee.med_foto}
                    name={ticket.assignedEmployee.med_naam}
                    size={8}
                  />
                )}
              </TableItem>
              <TableItem>
                <Typography tag="span" type="label">
                  <ul className="flex flex-wrap">
                    <li className="mr-4">
                      <Time icon={1} time={ticket.created_at} />
                    </li>
                    <li>
                      <DateFormatted icon={1} date={ticket.created_at} />
                    </li>
                  </ul>
                  <TruncateString
                    text={`${ticket.tic_onderwerp} | ${ticket.tic_omschrijving}`}
                    limit={45}
                  />
                </Typography>
              </TableItem>
              <TableItem>
                <Tag style={ticket.tic_status} label={ticket.tic_status} />
              </TableItem>
              <TableItem>
                <button onClick={() => viewDetail(ticket)}>
                  <Eye size={16} />
                </button>
              </TableItem>
            </tr>
          ))}
        </Table>
      ) : (
        <Typography type={'default'} tag={'p'}>
          Geen tickets
        </Typography>
      )}
    </Box>
  );
};

export default TicketLatest;
